// extracted by mini-css-extract-plugin
export default {"header":"HeaderTitleContent_header__tRnjT","header__title":"HeaderTitleContent_header__title__fP-Vw","header__back-btn":"HeaderTitleContent_header__back-btn__cwpBI"};